
import Vue from "vue";
import { TRUCK_SHORTCUT } from "@/consts";
import TruckHeader from "@/components/truck/TruckHeader.vue";
import TrucksActions from "@/components/truck/TrucksActions.vue";
import TruckOrderList from "@/components/truck/TruckOrderList.vue";
import Component from "vue-class-component";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";
import permissions from "@/security/permissions";
import { DriverResource } from "../models/api/drivers/get";
const truckModuleState = getModule(TruckModule);

@Component({
  components: {
    TruckHeader,
    TrucksActions,
    TruckOrderList
  }
})
export default class TruckDetail extends Vue {
  shortcuts: any = TRUCK_SHORTCUT;
  error: boolean = null;
  errorMessage: string = null;
  drivers: DriverResource[] = [];
  loading: boolean = false;

  get truckSystemLoading(): boolean {
    return truckModuleState.loading;
  }

  get hasError() {
    return !this.loading && this.error;
  }

  get truck() {
    return truckModuleState.currentTruck;
  }

  async created() {
    this.loading = true;
    if (!this.hasPermission(permissions.truck.view.detail)) {
      this.errorMessage = "You do not have permission to view truck details.";
      this.error = true;
      this.loading = false;
      return;
    }

    try {
      await truckModuleState.loadTruck(+this.$route.params.idx);
    } catch (ex) {
      this.error = true;
      if (ex.response && ex.response.data && ex.response.data.message)
        this.errorMessage = ex.response.data.message;
      else this.errorMessage = "Please ensure the truck exists and try again.";
    }

    try {
      if (this.truck) {
        this.drivers = await truckModuleState.getDrivers({ facilityCode: this.truck.facilityCode });
      }
    } catch (ex) {
      this.error = true;
      if (ex.response && ex.response.data && ex.response.data.message)
        this.errorMessage = ex.response.data.message;
      else this.errorMessage = "Failed to load driver list.";
    }

    this.loading = false;
  }

  async reload() {
    this.loading = true;
    if (!this.hasPermission(permissions.truck.view.detail)) {
      this.errorMessage = "You do not have permission to view truck details.";
      this.error = true;
      this.loading = false;
      return;
    }
    try {
      await truckModuleState.reloadTruck();
    } catch (ex) {
      this.error = true;
      if (ex.response.data && ex.response.data.message)
        this.errorMessage = ex.response.data.message;
      else this.errorMessage = "Please ensure the truck exists and try again.";
    }

    this.loading = false;
  }
}
